// extracted by mini-css-extract-plugin
export var carrierIcon = "_yy-0";
export var carrierLogo = "_yy-1";
export var detailsSection = "_yy-2";